export enum AttachmentStatus {
  NEW = "NEW",
  REMOVED = "REMOVED",
  DOWNLOADING = "DOWNLOADING",
  LOADED = "LOADED",
}
